import { toast } from "sonner";
import CricketFlag from "../../_components/CricketFlag";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CricketTeamDelete } from "@services/CricketTeam";
import { usePathname } from "@utils/hook/index.hook";
import { ColumnType } from "@utils/interface/index.interface";
import PlayersCell from "./playersColumn";
import CricketDialog from "../../../_components/CricketDialog";
import CricketTeamForm from "../form/index.form";

export type CricketTeamType = {
  id: number;
  players: {
    id: number;
    name: string;
  }[];
  name: string;
  iso_code: string;
};
//add
const ColumnList = () => {
  const queryClient = useQueryClient();
  const pathname = usePathname();

  const { mutate: DeleteTeam } = useMutation({
    mutationFn: (id: number) => CricketTeamDelete(id),
    onSuccess: () => {
      toast.success("Team deleted successfully");
      queryClient.invalidateQueries({
        queryKey: [`${pathname}-listing`],
      });
    },
    onError: (error) => {
      toast.error("Failed to delete team");
      console.error(error);
    },
  });

  const column: ColumnType<CricketTeamType>[] = [
    {
      name: "SN",
      cell: (row) => (
        <span className="font-semibold text-gray-700">{row.id}</span>
      ),
      sortable: true,
    },
    {
      name: <div className=" text-center">Team Name</div>,
      cell: (row) => (
        <div className="flex items-center justify-center gap-3 w-full">
          <CricketFlag
            isoCode={row.iso_code}
            className="text-2xl shadow-sm rounded-full w-8 h-8"
            title={row.name}
          />
          <span className="font-semibold text-gray-800">{row.name}</span>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Players",
      cell: (row) => <PlayersCell row={row} />,
      sortable: false,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex gap-2 font-medium cursor-pointer">
          <CricketDialog
            title="Update Team"
            trigger={
              <span className="text-teal-600 hover:underline">Edit</span>
            }
          >
            <CricketTeamForm formdata={row} />
          </CricketDialog>
          <span
            className="text-red-500 hover:underline"
            onClick={() => {
              if (
                window.confirm("Are you sure you want to delete this team?")
              ) {
                DeleteTeam(row.id);
              }
            }}
          >
            Delete
          </span>
        </div>
      ),
      sortable: false,
    },
  ];
  return column;
};

export { ColumnList };
